import Box from "@mui/material/Box";
import Skeleton from "../../../../../CommonComponents/Skeleton";

export const SOAFullComponentSkeleton = () => {
  return (
    <Box
        sx={{width:'100%',height:"96px",display:"flex",gap:"12px",bgcolor: "white",padding:"10px 8px",borderRadius:"8px"}}
    >
        <Skeleton animation="wave" sx={{width:"197px",height:"62px"}}/>
        <Box sx={{display:"flex",gap:"12px",height:"64px"}}>
            {Array.from({ length: 3 }).map((_, i) => (
                <Skeleton key={i} animation="wave" sx={{width:"264px",height:"62px"}}/>
            ))}
        </Box>
        <Skeleton sx={{width:"100%",height:"62px", padding:"0 8px 0 0"}} animation="wave"/>
    </Box>
  )
}
